/** Tope de UIDs por request de los endpoints bulk del BE. */
export const BULK_BATCH_SIZE = 5;

/** Máximo de batches en vuelo simultáneamente al orquestar un bulk. */
export const BULK_MAX_CONCURRENT_BATCHES = 5;

/** Tope máximo de protocolos seleccionables a la vez en el listado. */
export const BULK_MAX_SELECTION = 50;

export const BulkActionType = {
  FACTURADO: 'facturado',
  NO_FACTURADO: 'no_facturado',
  COBRADO: 'cobrado',
  NO_COBRADO: 'no_cobrado',
  CERRAR: 'cerrar',
} as const;
export type BulkActionType = (typeof BulkActionType)[keyof typeof BulkActionType];
